module.exports = __webpack_public_path__ + "img/dept-3.b8f39d14.svg";